import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Image } from '@lt/components';
import SideNavMenu from 'src/components/Header/components/HeaderMenu/components/SideNavMenu';

import TourGuide from 'src/components/Banners/TourGuide';

import HeaderWriteUs from 'src/components/Header/components/HeaderMenu/components/HeaderWriteUs';
import Auth from 'src/routes/Mobile';
import HeaderBanner from 'src/components/Banners/HeaderBanner';
import { useSidebarOpener } from 'src/components/Layout/hooks/useSidebarOpener';
import Header from '../Header';
import SearchForm from '../SearchForm';
import DynamicDataWrapper from './components/DynamicDataWrapper';
import HomeLtBottomPromo from './components/HomeLtBottomPromo';
import CountriesList from '../CountriesList';
import Relinking from '../Relinking';

import type { MobileSearchBlockProps } from './types';

const MobileSearchBlock = ({
  isWhitelabel,
  isWebView,
  isLoggedIn,
  onLogOut,
  partnerLogo,
  onShowAuthPopup,
}: MobileSearchBlockProps): JSX.Element => {
  const { isSidebarOpened, openSidebar, closeSidebar } = useSidebarOpener();
  const [isSSR, setIsSSR] = useState(true);

  /* force rerender on client, issue: https://github.com/vercel/next.js/issues/7417#issuecomment-509411508 */
  useEffect(() => {
    setIsSSR(false);
  }, []);

  useEffect(() => {
    if (window && window.PARTNER && window.PARTNER.id === 1190)
      window.postMessage(
        { event: 'frameRenderSuccess', success: true },
        'https://tinkoff-tours.level.travel/',
      );
  }, []);

  return (
    <>
      <View>
        {isSidebarOpened && (
          <SideNavMenu
            onShowAuthPopup={onShowAuthPopup}
            onLogOut={onLogOut}
            closeSidebar={closeSidebar}
            isWhitelabel={isWhitelabel}
            isLoggedIn={isLoggedIn}
          />
        )}

        <TopGradient />
        <BottomGradient />
        <StyledImage
          src="https://cdn.level.travel/lt-modules-assets/main/header_bg_portrait.webp"
          fallback="https://cdn.level.travel/lt-modules-assets/main/header_bg_portrait.jpg"
          alt="preview image"
        />
        {!isSSR && <HeaderBanner />}
        <Header
          redirectLogoLink="/"
          onBurgerClick={openSidebar}
          partnerLogo={partnerLogo}
          isWhitelabel={isWhitelabel}
          isHideMenu={isWebView}
        />
        {!isSSR && (
          <DynamicDataWrapper>
            <SearchForm />
          </DynamicDataWrapper>
        )}
      </View>
      <StyledTourGuideBannerWrapper>
        <TourGuide isMobile />
      </StyledTourGuideBannerWrapper>
      <Relinking isMobile />
      <HeaderWriteUs />
      {!isSSR && <Auth />}
      {!isWhitelabel && (
        <>
          <HomeLtBottomPromo isMobile />
          <CountriesList isMobile />
        </>
      )}
    </>
  );
};

const View = styled.section`
  position: relative;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  z-index: 1;
`;

const StyledImage = styled(Image)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  filter: brightness(65%);
`;

const TopGradient = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  mix-blend-mode: normal;
  opacity: 0.2;
  height: 14vh;
  width: 100%;
  z-index: 1;
`;

const BottomGradient = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  mix-blend-mode: normal;
  opacity: 0.6;
  height: 37vh;
  width: 100%;
  z-index: 1;
`;

const StyledTourGuideBannerWrapper = styled.div`
  padding: 8px 4px 0;
`;

export default MobileSearchBlock;
